// /ops/jobs — «Фоновые задачи» (002). Право — ops.jobs.read (сопровождение). Поиск по номеру
// операции, фильтры и сортировка — в адресе страницы (?q=&type=&state=&sort=): ссылку
// «Упали: N» с панели состояния можно открыть сразу с фильтром.
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { JobsPage } from '../../features/ops/JobsPage.tsx';
import { parseJobsSearch } from '../../features/ops/jobs-search.ts';
import type { JobsSearch } from '../../features/ops/jobs-search.ts';
import { requireSection } from '../../shell/permissions.ts';

export const Route = createFileRoute('/_app/ops/jobs')({
  validateSearch: parseJobsSearch,
  beforeLoad: requireSection('jobs'),
  staticData: { crumb: 'Фоновые задачи' },
  component: JobsRoute,
});

function JobsRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const onSearchChange = useCallback(
    (next: JobsSearch) => void navigate({ to: '/ops/jobs', search: next, replace: true }),
    [navigate],
  );
  return <JobsPage search={search} onSearchChange={onSearchChange} />;
}
